import { render } from "./SortingPanel.vue?vue&type=template&id=7b1b638e&scoped=true&ts=true"
import script from "./SortingPanel.vue?vue&type=script&lang=ts"
export * from "./SortingPanel.vue?vue&type=script&lang=ts"

import "./SortingPanel.vue?vue&type=style&index=0&id=7b1b638e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1b638e"]])

export default __exports__